export enum ReceiptExpensePickingListPayStatus {
    Collected = 1,
    NotYetCollect = 2,
    Payed = 3,
    NotYetPay = 4,
    AwaitConfirm = 5,
    Confirm = 6,
}